export default "__VITE_ASSET__BtpehuUW__"